<template>
  <div>
    <nav id="nav">
      <span class="hamburger" v-on:click="openNav()">&#9776;</span>
      <ul>
        <li>
          <router-link to="/horaire">Horaire</router-link>
        </li>
        <li>
          <router-link to="/enfants">Enfants</router-link>
        </li>
        <li>
          <router-link to="/heures_prestees">heures prestées</router-link>
        </li>
        <li>
          <router-link to="/depenses">Dépenses</router-link>
        </li>
        <li>
          <router-link to="/outils_educatifs">Outils éducatifs</router-link>
        </li>
        <li>
          <a href="#" @click="logout">
            Gaetane hdef
            <img id="portrait" src="../assets/portrait.png" />
          </a>
        </li>
      </ul>
    </nav>
    <div id="application_center">
      <router-view></router-view>
    </div>
  </div>
</template>

<style lang="scss">
$menu-bar-height: 6vh;
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  border: 0;
}
html {
  height: 100%;
  overflow: hidden;
  background-color: #e7e7de;
}
nav {
  background-color: #0f3057;
  height: $menu-bar-height;
  position: relative;
  z-index: 2;
}
nav ul {
  display: flex;
  width: 100%;
  align-items: center;
  font-size: 1rem !important;
}
nav ul li {
  list-style: none;
  height: 100%;
  line-height: 100%;
  vertical-align: middle;
  width: 10rem;
  text-align: center;
}

nav ul li a {
  text-decoration: none;
  color: white !important;
  height: 100%;
  width: 100%;
  display: block;
  line-height: $menu-bar-height;
}

nav ul li:hover {
  animation: show_shadow 0.3s forwards;
}
.router-link-exact-active {
  background-color: #0f3057;
  box-shadow: 0 5px #018891;
}
nav ul li:last-child {
  width: 20%;
  margin-left: auto;
}

#portrait {
  height: 5vh;
  border-radius: 50%;
  border: white 1px solid;
  display: inline-block;
  vertical-align: middle;
  margin-left: 5%;
}

@keyframes show_shadow {
  from {
    box-shadow: 0 0px #018891;
  }
  to {
    box-shadow: 0 5px #018891;
  }
}

#application_center {
  background-color: #e7e7de;
  padding-top: 3vh;
  padding-left: 3%;
  padding-right: 3%;
  height: 100vh;
  position: relative;
  z-index: 1;
}
.hamburger {
  display: none;
}
@media only screen and (min-width: 901px) {
  #application_center {
    margin-left: 0rem !important;
    transition: 0.5s;
  }
}
@media only screen and (max-width: 900px) {
  html {
    font-size: 90% !important;
  }
  #application_center {
    z-index: 3;
  }

  .hamburger {
    color: white;
    font-size: 30px;
    cursor: pointer;
    display: block;
    margin-left: 3%;
    height: $menu-bar-height;
  }
  nav ul {
    background-color: #0f3057;
    flex-direction: column;
    align-items: start;
    width: 100%;
    margin-left: -100%;
    transition: 0.5s;
    height: 100vh;
    font-size: 1.6rem !important;
  }
  .responsive ul {
    margin-left: 0px;
    transition: 0.5s;
  }
  nav ul li {
    width: 100%;
    height: 15.66vh;
  }
  nav .router-link-exact-active {
    background-color: #018891;
  }
  nav ul li a {
    padding-top: 50px;
  }
  nav ul li:first-child {
    border-top: 3px solid #018891;
  }

  nav ul li:last-child {
    width: 100%;
    margin-left: auto;
  }
  #application_center {
    transition: margin-left 0.5s;
  }
  nav ul li:hover {
    animation: none;
  }
}
</style>

<script>
export default {
  methods: {
    openNav() {
      const x = document.getElementById("nav");
      const main = document.getElementById("application_center");
      if (x.className === "") {
        x.className += "responsive";
        main.style.marginLeft = "100%";
      } else {
        x.className = "";
        main.className = "";
        main.style.marginLeft = "0rem";
      }
    },
  logout () {
    sessionStorage.clear();
    this.$router.replace("/")
  }
  }
};
</script>
